export default __webpack_public_path__ + "static/media/livrygargan.cfbcef68.jpg";